import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';

export const ToolCard = ({ tool }) => {
  const Icon = tool.icon;

  return (
    <Link to={tool.href}>
      <Card className="h-full hover-lift border-border hover:border-primary/50 hover:shadow-primary transition-smooth group">
        <CardHeader>
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-smooth">
              <Icon className="w-6 h-6" />
            </div>
            {tool.popular && (
              <Badge variant="secondary" className="bg-secondary/10 text-secondary hover:bg-secondary/20 border-secondary/20">
                Popular
              </Badge>
            )}
          </div>
          <CardTitle className="text-lg group-hover:text-primary transition-smooth">
            {tool.name}
          </CardTitle>
          <CardDescription className="line-clamp-2">{tool.description}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-2 mb-4">
            {tool.tags.slice(0, 3).map((tag, index) => (
              <Badge key={index} variant="outline" className="text-xs">
                {tag}
              </Badge>
            ))}
          </div>
          <div className="flex items-center text-sm text-primary font-medium group-hover:gap-2 transition-smooth">
            Calculate Now
            <ArrowRight className="w-4 h-4 ml-1 group-hover:ml-2 transition-smooth" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
